var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"variant-divider",class:{
    'left-border': !_vm.hideLeftBorder,
    'right-border': !_vm.hideRightBorder
  }},[_c('IxRes',[_vm._v("frs.dlgCertIntegration.modals.harvestYearHelp.diagram.labels.divider")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }